import React from 'react'
import style from '../card.module.css'

function Test6() {
  return (
    <div className={style.prepration_card}>
        <h3>NDA 2021: Science Free Test</h3>
        <button>Free</button> 
        <div>
        <p>Test 3 . Mar 6, 6:30 PM</p>      
        </div>     
    </div>
  )
}

export default Test6